import { render, staticRenderFns } from "./WobbleHeart.vue?vue&type=template&id=164d4293&"
import script from "./WobbleHeart.vue?vue&type=script&lang=js&"
export * from "./WobbleHeart.vue?vue&type=script&lang=js&"
import style0 from "./WobbleHeart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports